import React, { type FC, useEffect } from 'react';

import Box from '../../../Box/Box';
import Button from '../../../Button/Button';
import { contactLandownerButtonStyles } from './ContactLandownerButton.styles';

export type ContactLandownerButtonProps = {
  /**
   * URL to navigate to when the button is clicked
   */
  url: string;
  /**
   * Custom button text
   * @default "Contact Landowner"
   */
  buttonText?: string;
  /**
   * Target attribute for the link (e.g., "_blank" to open in new tab)
   */
  target?: '_blank' | '_self' | '_parent' | '_top';
  /**
   * Callback fired when the button is displayed/rendered
   * Useful for analytics tracking
   */
  onDisplay?: () => void;
  /**
   * Callback fired when the user clicks the button
   * Useful for analytics tracking
   */
  onClick?: () => void;
  /**
   * Additional CSS class names
   */
  className?: string;
};

export const ContactLandownerButton: FC<ContactLandownerButtonProps> = ({
  url,
  buttonText = 'Contact Landowner',
  target,
  onDisplay,
  onClick,
  className,
}) => {
  useEffect(() => {
    onDisplay?.();
  }, [onDisplay]);

  return (
    <Box marginTop="var(--spacing-4)">
      <Button
        variant="primary"
        size="base"
        as="a"
        href={url}
        target={target}
        rel={target === '_blank' ? 'noopener noreferrer' : undefined}
        onClick={onClick}
        css={contactLandownerButtonStyles}
        className={className}
      >
        {buttonText}
      </Button>
    </Box>
  );
};
